
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/anchors/components/anchorVariables.scss.css.virtualfile';
        module.exports = {"anchorHandleWidth":"140px","anchorHandleHeight":"24px","anchorHandleMarginRight":"68px"};